// Bootstrap
import "bootstrap/js/dist/base-component";
import "bootstrap/js/dist/alert";
import "bootstrap/js/dist/button";
import "bootstrap/js/dist/carousel";
import "bootstrap/js/dist/collapse";
import "bootstrap/js/dist/dropdown";
import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/offcanvas";
import "bootstrap/js/dist/popover";
import "bootstrap/js/dist/scrollspy";
import "bootstrap/js/dist/tab";
import "bootstrap/js/dist/toast";
import "bootstrap/js/dist/tooltip";


// var tooltipTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="tooltip"]')
// );
// var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
// 	return new bootstrap.Tooltip(tooltipTriggerEl);
// });

// var popoverTriggerList = [].slice.call(
// 	document.querySelectorAll('[data-bs-toggle="popover"]')
// );
// var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
// 	return new bootstrap.Popover(popoverTriggerEl);
// });

// Custom

import initNavScroll from './navScroll';
import InitGsap from './InitGsap';

initNavScroll();
InitGsap();

// Inject shipping notice into WooCommerce block cart
const shippingNoticeText = 'All deliveries are sent through AN POST on Monday. Delivery is generally within 2 days of dispatch.';
const shippingNoticeClass = 'shipping-delivery-notice';

function injectShippingNotice() {
	const target = document.querySelector('.wc-block-components-totals-shipping__collaterals');
	if (target && !target.querySelector('.' + shippingNoticeClass)) {
		const notice = document.createElement('p');
		notice.className = shippingNoticeClass;
		notice.textContent = shippingNoticeText;
		target.appendChild(notice);
	}
}

const shippingObserver = new MutationObserver(injectShippingNotice);
shippingObserver.observe(document.body, { childList: true, subtree: true });
injectShippingNotice();

// Quantity plus/minus buttons
document.addEventListener('click', function (e) {
	if (e.target.classList.contains('quantity-plus') || e.target.classList.contains('quantity-minus')) {
		const wrapper = e.target.closest('.quantity-wrapper');
		const input = wrapper ? wrapper.querySelector('input.qty') : null;
		if (!input) return;

		const min = parseInt(input.min) || 1;
		const max = parseInt(input.max) || Infinity;
		let val = parseInt(input.value) || 1;

		if (e.target.classList.contains('quantity-plus')) {
			if (val < max) input.value = val + 1;
		} else {
			if (val > min) input.value = val - 1;
		}

		input.dispatchEvent(new Event('change', { bubbles: true }));
	}
});
